"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
exports.defaultOptions = {
    attributeName: "gatsby-plugin-fix-fouc-is-loading",
    minWidth: 0,
    timeout: 4000,
};
